import { render } from "./GridDepartamento.vue?vue&type=template&id=2990fa38&scoped=true"
import script from "./GridDepartamento.vue?vue&type=script&lang=js"
export * from "./GridDepartamento.vue?vue&type=script&lang=js"

import "./GridDepartamento.vue?vue&type=style&index=0&id=2990fa38&scoped=true&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2990fa38"]])

export default __exports__